import { createRouter, createWebHashHistory } from 'vue-router'
import { decodePath } from '../utils/routeEncoder'
import { isLoggedIn as checkSession, logout as sessionLogout } from '../utils/sessionManager'
import Login from '../views/Login.vue'
import MainLayout from '../components/MainLayout.vue'
import NotFound from '../views/NotFound.vue'
import AiChat from '../views/AiChat.vue'
import DocPreview from '../views/DocPreview.vue'
import MailCompose from '../views/MailCompose.vue'
import MsgList from '../views/MsgList.vue'
import TaskPrint from '../views/TaskPrint.vue'
import ReportViewer from '../views/ReportViewer.vue'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: MainLayout,
    meta: { requiresAuth: true }
  },
  { path: '/404', name: 'NotFound', component: NotFound },
  { 
    path: '/ai-chat', 
    name: 'AiChat', 
    component: AiChat, 
    meta: { requiresAuth: true } 
  },
  {
    path: '/doc-preview',
    name: 'DocPreview',
    component: DocPreview,
    meta: { requiresAuth: true }
  },
  {
    path: '/mail-compose',
    name: 'MailCompose',
    component: MailCompose,
    meta: { requiresAuth: true }
  },
  {
    path: '/msg-list',
    name: 'MsgList',
    component: MsgList,
    meta: { requiresAuth: true }
  },
  {
    path: '/print/:taskId',
    name: 'TaskPrint',
    component: TaskPrint,
    meta: { requiresAuth: true }
  },
  {
    path: '/report-viewer',
    name: 'ReportViewer',
    component: ReportViewer,
    meta: { requiresAuth: true }
  },
  { path: '/:code', name: 'Encoded', component: MainLayout, meta: { requiresAuth: true } },
  { path: '/:pathMatch(.*)*', redirect: '/404' }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.params.code && !to.path.startsWith('/login')) {
    const decodedPath = decodePath(to.params.code)
    if (decodedPath && decodedPath !== to.path) {
      next(decodedPath)
      return
    }
  }

  const isAuth = checkSession()

  if (to.meta.requiresAuth && !isAuth) {
    next('/login')
  } else if (to.path === '/login' && isAuth) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
